import { useLang } from "@/lib/i18n";

export default function AdsensePlaceholder({ position = "default" }) {
  const { t } = useLang();
  return (
    <div
      className="adsense-banner my-12 mx-auto max-w-3xl border border-dashed border-[var(--cor-borda)] rounded-sm py-10 text-center"
      data-testid={`adsense-${position}`}
    >
      <div className="font-display text-[10px] uppercase tracking-[0.32em] text-[var(--cor-texto-2)]/40">
        {t.publicidade}
      </div>
    </div>
  );
}
